import { render, staticRenderFns } from "./done-old.vue?vue&type=template&id=18913e78&scoped=true"
import script from "./done-old.vue?vue&type=script&lang=js"
export * from "./done-old.vue?vue&type=script&lang=js"
import style0 from "./done-old.vue?vue&type=style&index=0&id=18913e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18913e78",
  null
  
)

export default component.exports